import { get as lodashGet } from "lodash-es";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

export const useEnableSearchAPIOnMentionableThreadUsers = () => {
  const { data: config } = useInstanceConfigQuery();
  return lodashGet(
    config,
    "feature_toggles.ENABLE_SEARCH_API_ON_MENTIONABLE_THREAD_USERS",
    false
  );
};
